<script setup lang="ts">
const props = defineProps<{ productId: number; showLabel: boolean }>();
const { isInWishlist } = useWishlist();
const { onToggleWishlist, isLoading, isDisabled } = useToggleWishlist();
const icon = computed(() => {
  if (isLoading.value) return "i-local-loading animate-spin";
  return isInWishlist.value(props.productId) ? "i-local-heart-filled" : "i-local-heart";
});
const label = computed(() => isInWishlist.value(props.productId) ? "Retirer de mes favoris" : "Ajouter à mes favoris");
</script>

<template>
  <button :disabled="isDisabled" :class="showLabel ? 'link-primary flex items-center gap-1 text-lg' :'btn-outline-circle'" @click="onToggleWishlist({ product_id: productId })">
    <span class="size-6" :class="icon" />
    <span v-if="showLabel">{{ label }}</span>
  </button>
</template>
